import React from 'react';

function Contact(props) {
    return (
        <div className="p-3">
            <h3 className="contact-heading pt-4 mt-5">
                Contact Us
            </h3>
            <p className="contact-sub-heading">
                We will Love to hear from you
            </p>
            <form>
                <div className="mb-3 col col-8">
                    <label for="exampleInputEmail1" className="form-label">Email address</label>
                    <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"/>
                    <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
                </div>
                <div className="mb-3 col col-8">
                    <label for="exampleInputPassword1" className="form-label">Talk to us</label>
                    <textarea className="form-control" id="exampleInputPassword1"></textarea>
                </div>
                <button type="submit" className="btn btn-primary">Submit</button>
            </form>
        </div>
    );
}

export default Contact;